import React, { Component } from 'react';
import { Button, Card, Input, Modal } from 'antd';
import UpdateableTable from '../../common/tables/UpdateableTable';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

const Search = Input.Search;

export default class AjaxTable extends Component {
    static propTypes = {
      authToken: PropTypes.string,
      title: PropTypes.string.isRequired,
      getColumns: PropTypes.func.isRequired,
      updateData: PropTypes.func,
      selectData: PropTypes.func.isRequired,
      createData: PropTypes.func,
      defaultData: PropTypes.object,
      deleteData: PropTypes.func,
      searchable: PropTypes.bool,
    }

    state = {
      columns: [],
      data: [],
      loading: false,
      pagination: {},
      modalVisible: false,
      dataToDelete: {},
      search: '',
    }

    getData(params) {
      const pageParams = params || {};
      const { authToken, selectData } = this.props;
      const { search } = this.state;
      const queryParams = {
        ...pageParams,
        ...(search ? {
          search: search,
        } : {}),
      };

      this.setState({ loading: true });
      selectData(authToken, queryParams).then((results) => {
        const { data, limit, page, total } = results;
        const pagination = {
          current: page,
          pageSize: limit,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          total
        };

        const sortedData = data.sort((a, b) => a.id - b.id );
    
        this.setState({
          loading: false,
          pagination,
          data: sortedData,
        });
      }).catch(err => {
        this.setState({
          loading: false,
          data: []
        });
      });
    }

    componentDidMount() {
      const { getColumns, authToken } = this.props;
      getColumns(authToken).then((columns) => this.setState({ columns }));
      this.getData();
    }
    
    // (pagination, filters, sorter)  Can use sorter also
    handleTableChange = (pagination, filters) => {
      const newPagination = {
        ...this.state.pagination,
        current: pagination.current
      };
      this.setState({ pagination: newPagination });
      this.getData({
        limit: newPagination.pageSize,
        page: newPagination.current,
        filters
      });
    }

    updateData = (newData) => {
      const { authToken, updateData, createData } = this.props;
      const { data, pagination } = this.state;
      let promise;
      if (data.find(item => item.id === newData.id)) {
        if (!updateData) {
          return Promise.reject();
        }
        promise = updateData(authToken, newData);
      } else {
        if (!createData) {
          return Promise.reject();
        }
        promise = createData(authToken, newData);
      }
      return promise.then(this.getData({ limit: pagination.pageSize, page: pagination.current }));
    }

    appendDefaultData = () => {
      const { defaultData } = this.props;

      const _ = require("lodash");
      // Generate a temporary Realm using lodash to generate a char string
      //  https://stackoverflow.com/questions/58325771/how-to-generate-random-hex-string-in-javascript
      defaultData.realm = "temp" + _.times(6, () => (Math.random()*0xF<<0).toString(16)).join('');
      
      const { pagination, search } = this.state;

      // Handles adding a new page.
      const lastPage = Math.ceil(pagination.total / pagination.pageSize);
      let newPagination;
      if (pagination.total % 10 === 0) {
        newPagination = { ...pagination, current: lastPage + 1 };
      } else {
        newPagination = { ...pagination, current: lastPage };
      }

      let data;
      search ? data = { ...defaultData, realm: search, accountId: search } : data = defaultData;
      return this.updateData(data).then((res) => {
        this.handleTableChange(newPagination);
        return res;
      });
    }

    deleteData = (data) => {
      this.setState({ modalVisible: true, dataToDelete: data });
    }

    handleModalOk = () => {
      const { authToken, deleteData } = this.props;
      const { pagination, dataToDelete } = this.state;

      this.setState({ modalVisible: false, dataToDelete: {} });
      deleteData(authToken, dataToDelete.id).then(() => {
        this.getData({ limit: pagination.pageSize, page: pagination.current });
      });
    }

    handleModalCancel = () => {
      this.setState({ dataToDelete: {}, modalVisible: false });
    }

    searchData = (value) => {
      this.setState({
        search: value,
      }, debounce(() => {
        this.getData();
      }, 200));
    }

    resetData = () => {
      this.setState({
        search: '',
      }, () => {
        this.getData();
      });
    }

    handleSearchChange = (e) => {
      this.setState({
        search: e.target.value,
      });
    }

    render() {
      const {
        data,
        loading,
        pagination,
        columns,
        modalVisible,
        search,
      } = this.state;

      const {
        title,
        createData,
        deleteData,
        searchable,
      } = this.props;

      return (
        <div>
          <Card title={<h1>{title}</h1>} style={{ background: '#ECECEC', padding: '30px' }}>
            { searchable ? (
              <div style={{ marginBottom: '10px' }}>
                <Search
                  placeholder='Search by Account ID or Domain'
                  onSearch={value => this.searchData(value)}
                  style={{ width: '300px' }}
                  enterButton='Search'
                  onChange={this.handleSearchChange}
                  value={search}
                />
                <Button
                  style={{ marginLeft: '5px' }}
                  onClick={ () => this.resetData() }
                >
                  Reset
                </Button>
              </div> ) : undefined
            }
            <UpdateableTable
              columns={columns}
              rowKey={row => row.id}
              data={data}
              loading={loading}
              pagination={pagination}
              onChange={this.handleTableChange}
              bordered
              updateFun={this.updateData}
              createable={typeof createData === 'function'}
              appendDefaultData={this.appendDefaultData}
              deleteData={this.deleteData}
              deleteable={typeof deleteData === 'function'}
            />
          </Card>
          <Modal
            title={`Delete From ${title} Table`}
            visible={modalVisible}
            onOk={this.handleModalOk}
            onCancel={this.handleModalCancel}
          >Are you sure you want to delete this record?</Modal>
        </div>
      );
    }
}
